import { useTranslation } from "react-i18next";

import DialogActions from "components/Actions/dialogs/components/DialogActions";
import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";

import { ReceiveDeviceProps } from "../../types";

const ReceiveDeviceActions = ({
    loading,
    token,
    company,
    close,
    goToMainScreen
}: ReceiveDeviceProps) => {
    const { t } = useTranslation();

    return !token ? (
        <DialogActions
            onClose={goToMainScreen}
            isLoading={loading}
            isReadyToConfirm={token ? true : company !== null}
            confirmationButtonText={t("Button##confirm")}
            secondaryButtonText={t("Button##back")}
            cancelButtonTestId="cancel-receive-devices"
            confirmationButtonTestId="confirm-receive-devices"
        />
    ) : (
        <Button
            fullWidth
            color={BUTTON_COLORS.Secondary}
            size={BUTTON_SIZES.Normal}
            variant={BUTTON_VARIANTS.TextOnly}
            onClick={close}
        >
            {t("Button##close")}
        </Button>
    );
};
export default ReceiveDeviceActions;
